import { Component, OnInit } from '@angular/core'

@Component({
    standalone: false,
    selector: 'app-notfound',
    templateUrl: './notfound.component.html',
    styleUrls: ['./notfound.component.css']
})
export class NotfoundComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
